"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainExplorer = void 0;
const definitions_1 = require("@ppay/definitions");
exports.BlockchainExplorer = {
    [definitions_1.Blockchain.BINANCE_SMART_CHAIN]: {
        network: 'BEP20',
        ticker: definitions_1.Ticker.BNB,
        link: 'https://bscscan.com/tx/',
        address: 'https://bscscan.com/address/',
        title: 'bscscan.com'
    },
    [definitions_1.Blockchain.BITCOIN]: {
        network: 'Bitcoin',
        ticker: definitions_1.Ticker.BTC,
        link: 'https://www.blockchain.com/btc/tx/',
        address: 'https://www.blockchain.com/btc/address/',
        title: 'blockchain.com'
    },
    [definitions_1.Blockchain.ETHEREUM]: {
        network: 'ERC20',
        ticker: definitions_1.Ticker.ETH,
        link: 'https://etherscan.io/tx/',
        address: 'https://etherscan.io/address/',
        title: 'etherscan.io'
    },
    [definitions_1.Blockchain.TRON]: {
        network: 'TRC20',
        ticker: definitions_1.Ticker.TRX,
        link: 'https://tronscan.org/#/transaction/',
        address: 'https://tronscan.io/#/address/',
        title: 'tronscan.org'
    },
    [definitions_1.Blockchain.POLYGON]: {
        network: 'ERC20',
        ticker: definitions_1.Ticker.POL,
        link: 'https://polygonscan.com/tx/',
        address: 'https://polygonscan.com/address/',
        title: 'polygonscan.com'
    },
    [definitions_1.Blockchain.BASE]: {
        network: 'ERC20',
        ticker: definitions_1.Ticker.ETH,
        link: 'https://basescan.org/tx/',
        address: 'https://basescan.org/address/',
        title: 'basescan.org'
    },
    [definitions_1.Blockchain.SOLANA]: {
        network: 'SPL',
        ticker: definitions_1.Ticker.SOL,
        link: 'https://solscan.io/tx/',
        address: 'https://solscan.io/account/',
        title: 'solscan.io'
    },
    [definitions_1.Blockchain.ARBITRUM]: {
        network: 'ERC20',
        ticker: definitions_1.Ticker.ETH,
        link: 'https://arbiscan.io/tx/',
        address: 'https://arbiscan.io/address/',
        title: 'arbiscan.io'
    },
    [definitions_1.Blockchain.LITECOIN]: {
        network: 'Litecoin',
        ticker: definitions_1.Ticker.LTC,
        link: 'https://litecoinspace.org/tx/',
        address: 'https://litecoinspace.org/address/',
        title: 'litecoinspace.org'
    }
};
